import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { addUserRoles } from "src/app/core/models/user";
import {
  DepAppListObj,
  UserAppDetails,
  UserJobPath,
  UserJobPathData,
  UserProfileResponse,
  UserRoleNames,
  UserRolesInt,
} from "src/app/core/models/users";
import { UserService } from "src/app/core/services/user.service";
import { JobPriorityText } from "../../../../../../core/models/job";
import { ApplicationService } from "../../../../../../core/services/application.service";
import { NodeService } from "../../../../../../core/services/node.service";
import { Node } from "src/app/core/models/node";
import { format } from "path";
import { get } from "http";
import { error } from "console";
import { Deployment } from "src/app/core/models/deployment";
import { DeploymentService } from "src/app/core/services/deployment.service";

@Component({
  selector: "app-update-job-submit-id",
  templateUrl: "./update-job-submit-id.component.html",
  styleUrls: ["./update-job-submit-id.component.scss"],
})
export class UpdateJobSubmitIdComponent implements OnInit {
  types: addUserRoles[] = [
    {
      name: UserRoleNames.DeploymentAdmin,
      value: UserRolesInt.DeploymentAdmin,
    },
    // { name: UserRoleNames.PowerUser, value: UserRolesInt.PowerUser },
    { name: UserRoleNames.JobOperator, value: UserRolesInt.JobOperator },
  ];

  updateUserRoleForm: UntypedFormGroup;
  groups: string[] = [];
  jobPriorities = Object.values(JobPriorityText);
  maximumCoresAllowed: number = 0;
  alreadyAttachedNodeGroups: string[] = [];
  isGroupsAccessControl: boolean =
    this.data?.userInfo?.isGroupsAccessControl || false;
  forGlobalAdminOrReader: boolean =
    this.data?.userInfo?.forGlobalAdminOrReader || false;
  nodesData: Node[];
  alreadyMappedWorkstation: string;
  appList: DepAppListObj[] = this.data.userInfo?.userApps?.deploymentAppList;
  currentlyAllowedUserApps: string[] =
    this.data.userInfo?.userApps?.userAllowedApps?.split(",");
  title: string = this.data?.userInfo?.title;
  jobSelectedPath: Number = 3;
  jobPathOptions: UserJobPath[] = [];
  isVdi: boolean = this.data?.userInfo?.isVdi || false;
  updatedObject: UserProfileResponse;
  selApps: String[];
  storageList: string[] = [];
  deployments: Deployment;
  assignedStorages = this.data?.userInfo?.assignedStorages;
  constructor(
    public dialog: MatDialogRef<UpdateJobSubmitIdComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userInfo: {
        userName: string;
        deploymentName: string;
        currentUserRole: string;
        adminId: string;
        nodeGroup: string;
        mapWorkstation: string;
        jobPriority: string;
        jobSubmitId: string;
        allocatedCores: number;
        isGroupsAccessControl: boolean;
        userApps?: UserAppDetails;
        fromUserGroup: boolean;
        forGlobalAdminOrReader: boolean;
        title: string;
        sessionUserId: string;
        isVdi: boolean;
        jobPath: number;
        assignedStorages: string;
      };
      JobsLimits: {
        maxSubmitJobs: number;
        maxJobs: number;
      };
    },
    private userService: UserService,
    private snackBar: MatSnackBar,
    private applicationService: ApplicationService,
    private nodeService: NodeService,
    private depService: DeploymentService
  ) {
    this.initializeForm();
  }

  initializeForm() {
    this.updateUserRoleForm = new UntypedFormGroup({
      userRole: new UntypedFormControl(
        this.data?.userInfo?.currentUserRole || "",
        [Validators.required]
      ),
      nodeGroup: new UntypedFormControl(
        this.data?.userInfo?.nodeGroup?.split(",") || []
      ),
      mapWorkstation: new UntypedFormControl(
        this.data?.userInfo?.mapWorkstation || ""
      ),
      jobDirectoryPath: new UntypedFormControl(this.jobSelectedPath || 3),
      jobPriority: new UntypedFormControl(
        this.data?.userInfo?.jobPriority || ""
      ),
      jobSubmitUserId: new UntypedFormControl(
        this.data?.userInfo?.jobSubmitId || "",
        this.data?.userInfo?.userName ? [Validators.required] : []
      ),
      editAllocatedCoreQuota: new UntypedFormControl(
        this.data?.userInfo?.allocatedCores == 0
          ? "-1"
          : this.data?.userInfo?.allocatedCores?.toString() || "",
        [Validators.pattern("^[0-9]{1,5}|^-[1]{1}$")]
      ),
      updateApp: new UntypedFormControl(this.selApps),
      selectedAppLicense: new UntypedFormControl(
        this.data?.userInfo?.userApps?.userAllowedAppLicenses?.split(",") || []
      ),
      sessionUserIdForGAReader: new UntypedFormControl(
        this.data?.userInfo?.sessionUserId || ""
      ),
      maxJobs: new UntypedFormControl(this.data?.JobsLimits?.maxJobs, [
        Validators.required,
        Validators.pattern(/^(-1|[1-9]\d*)$/), // Either -1 or positive integer
      ]),
      maxSubmitJobs: new UntypedFormControl(
        this.data?.JobsLimits?.maxSubmitJobs,
        [
          Validators.required,
          Validators.pattern(/^(-1|[1-9]\d*)$/), // Either -1 or positive integer
        ]
      ),
      updateStorage: new UntypedFormControl(
        this.assignedStorages,
        !this.isGroupsAccessControl ? [Validators.required] : []
      ),
    });

    if(this.forGlobalAdminOrReader == true){
      this.updateUserRoleForm.controls['userRole'].clearValidators();
      this.updateUserRoleForm.controls['nodeGroup'].clearValidators();
    }
  }

  ngOnInit(): void {
    if (this.data.userInfo.nodeGroup) {
      this.alreadyAttachedNodeGroups = this.data.userInfo.nodeGroup?.split(",");
    }
    if (this.data.userInfo.mapWorkstation) {
      this.alreadyMappedWorkstation = this.data.userInfo.mapWorkstation;
    }
    this.selApps = this.appList
      ?.filter((e) => this.currentlyAllowedUserApps?.includes(e.uniqueId))
      .map((n) => n.uniqueId);
    this.getNodeGroup();
    this.checkNodeData();
    this.getUserJobPath(
      this.data.userInfo.userName,
      this.data.userInfo.deploymentName
    );
    this.deployments = this.depService.getProfileInfoesFromSubject()?.filter(x => x.name == this.data?.userInfo?.deploymentName)[0];
    if (this.deployments && this.deployments.storageAccountName) {
      this.storageList = this.deployments.storageAccountName.split(",");
    }
    this.updateFormValues();
  }

  updateFormValues() {
    if (this.updateUserRoleForm) {
      // Update job directory path when it loads
      this.updateUserRoleForm.patchValue({
        jobDirectoryPath: this.jobSelectedPath,
        updateApp: this.selApps,
      });
    }
  }

  getUserJobPath(userId: string, depName: string) {
    this.userService.getUserJobDirectoryPath(userId, depName).subscribe({
      next: (data: UserJobPathData) => {
        this.jobSelectedPath = data.deploymentData.jobValue;
        if (this.isGroupsAccessControl) {
          this.jobSelectedPath = this.data.userInfo.jobPath;
        }
        this.jobPathOptions = data.jobPathOptions;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  onClose() {
    this.dialog.close();
  }

  getNodeGroup() {
    this.applicationService
      .getNodeGroupsForDeployment(this.data.userInfo.deploymentName)
      .subscribe((data) => {
        this.groups = <string[]>JSON.parse(JSON.stringify(data));
        if (this.data.userInfo.nodeGroup == null) {
          this.updateUserRoleForm.get("nodeGroup").setValue(["Default"]);
        }
      });
  }

  onSubmit(form) {
    if (form.status == "INVALID") {
      this.updateUserRoleForm.markAllAsTouched();
      return;
    }
    let sessionUserId = this.data.userInfo.sessionUserId;
    sessionUserId = form.value?.sessionUserIdForGAReader?.toString();
    let updateObj = {
      userInfo: {
        userName: this.data.userInfo.userName,
        adminId: this.data.userInfo.adminId,
        depName: this.data.userInfo.deploymentName,
        userRole: this.forGlobalAdminOrReader ? this.data.userInfo.currentUserRole : form.value.userRole,
        nodeGroup: form.value.nodeGroup?.toString(),
        mappedWorkstation: form.value.mapWorkstation?.toString(),
        jobPriority: form.value.jobPriority,
        profileCoreQuota: form.value.editAllocatedCoreQuota,
        jobsubmitId: form.value.jobSubmitUserId,
        jobPath: form.value.jobDirectoryPath,
        userAppAccess: form.value?.updateApp?.join(","),
        userAppLicenses: this.getFilteredLicenseList()?.join(","),
        sessionUserId: sessionUserId,
        assignedStorages: form.value.updateStorage ? form.value.updateStorage : "",
      },
      JobsLimits: {
        maxJobs: form.value.maxJobs,
        maxSubmitJobs: form.value.maxSubmitJobs,
      },
    };
    this.dialog.close(updateObj);
  }

  checkNodeData() {
    this.nodeService
      .getNodesForDeployment(this.data.userInfo.deploymentName)
      .subscribe((data) => {
        if (!data) return;
        let nodes = <Node[]>JSON.parse(JSON.stringify(data));

        this.maximumCoresAllowed = nodes
          .filter((el) => el.nodeType.toLowerCase().includes("compute"))
          .map((el) => el.cores)
          .reduce((total, curr) => total + +curr, 0);
        //this.nodesData = nodes.filter(n => n.reserved == false);
        this.nodesData = nodes;
        this.updateUserRoleForm
          .get("editAllocatedCoreQuota")
          .setValidators([
            Validators.max(this.maximumCoresAllowed),
            this.updateUserRoleForm.get("editAllocatedCoreQuota").validator,
          ]);
        this.updateUserRoleForm
          .get("editAllocatedCoreQuota")
          .updateValueAndValidity();
      });
  }

  getAppList() {
    let apps: DepAppListObj[] =
      this.data.userInfo.userApps?.deploymentAppList.filter((e) =>
        this.updateUserRoleForm?.value?.updateApp.includes(e.uniqueId)
      ) || [];
    return apps?.filter((a) => a.avlLicenses && a.avlLicenses.length > 1);
  }

  getFilteredLicenseList() {
    let apps: DepAppListObj[] =
      this.data.userInfo.userApps?.deploymentAppList.filter((e) =>
        this.updateUserRoleForm.value.updateApp.includes(e.uniqueId)
      ) || [];
    let allLicenses = [];
    apps?.forEach((a) => {
      let licenses = a.avlLicenses;
      licenses?.forEach((l) => {
        allLicenses.push(`${a.appName}:${a.appVersion}:${l}`);
      });
    });
    return (
      this.updateUserRoleForm.value?.selectedAppLicense?.filter((l) =>
        allLicenses.includes(l)
      ) || null
    );
  }

  isOptionDisabled(app: DepAppListObj, license: string): boolean {
    let avlLicenses = app?.avlLicenses?.map(
      (l) => `${app.appName}:${app.appVersion}:${l}`
    );
    let selLicenses = this.updateUserRoleForm.value?.selectedAppLicense || [];
    let isOneValueSec = avlLicenses?.some((val) => selLicenses.includes(val));
    if (isOneValueSec) {
      if (
        selLicenses?.includes(`${app.appName}:${app.appVersion}:${license}`)
      ) {
        return false;
      }
      return true;
    }
    return false;
  }
}
